var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.validarPermisos('ActivityActividadesTurnos'))?_c('ModuloTurnos'):_vm._e(),_c('ModuloItem',{attrs:{"dataitem":_vm.getInfo()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }